// rootSaga.js

import { all } from "redux-saga/effects";

import { adminsSaga } from "./adminsSaga";
import { authSaga } from "./authSaga";
import { availabilitySaga } from "./availabilitySaga";
import { bookingsSaga } from "./bookingsSaga";
import { categoriesSaga } from "./categoriesSaga";
import { categoryTemplatesSaga } from "./categoryTemplatesSaga";
import { employeesSaga } from "./employeesSaga";
import { restorePasswordSaga } from "./restorePasswordSaga"
import { schedulesSaga } from "./schedulesSaga";
import { servicesSaga } from "./servicesSaga";
import { serviceTemplatesSaga } from "./serviceTemplatesSaga";
import { studioScheduleSaga } from "./studioScheduleSaga";
import { studiosSaga } from "./studiosSaga";
import { usersSaga } from "./usersSaga";

export default function* rootSaga () {
  yield all([
    authSaga(),
    adminsSaga(),
    studiosSaga(),
    servicesSaga(),
    serviceTemplatesSaga(),
    categoriesSaga(),
    categoryTemplatesSaga(),
    schedulesSaga(),
    employeesSaga(),
    bookingsSaga(),
    usersSaga(),
    availabilitySaga(),
    studioScheduleSaga(),
    restorePasswordSaga(),
  ]);
}
